<div class="map-schema-diagram">
  <div class="map-schema-diagram-canvas">
    <lib-gojs-schematic
      [substationId]="selectedSubstationId"
      [substationName]="selectedSubstation?.name ?? null"
      [viewOnly]="true"
    ></lib-gojs-schematic>

    <div *ngIf="!loading && noPublishedSchemas" class="map-schema-diagram-empty">
      No substation has a published schema diagram yet.
    </div>
  </div>

  <div class="overview">
    <div class="select-row">
      <app-single-select-dropdown2
        id="schema-template-filter"
        [items]="templateOptions"
        [displayProperty]="'className'"
        [searchFilterActive]="false"
        [showMore]="true"
        [label]="'Substation Template'"
        [selectedItem]="selectedTemplate"
        (shareSelectedItem)="onTemplateSelected($event)"
      ></app-single-select-dropdown2>

      <div class="divider"></div>

      <app-single-select-dropdown2
        id="schema-substation-filter"
        [items]="substationOptions"
        [searchFilterActive]="true"
        [showMore]="true"
        [maxDisplayItems]="5"
        [label]="'Substation Name'"
        [disabled]="!selectedTemplate"
        [selectedItem]="selectedSubstation"
        (shareSelectedItem)="onSubstationSelected($event)"
        (filterValue)="onSubstationFilterChange($event)"
      ></app-single-select-dropdown2>
    </div>
  </div>
</div>
